import cookies from 'js-cookie';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  data: () => ({
    isAgreementVisible: false,
    isAgreementRequestInProgress: false,
    agreementToken: '',
  }),
  computed: {
    ...mapState('session', ['redirectAfterLoginPath']),
  },
  methods: {
    ...mapMutations('session', ['redirectAfterLogin', 'setCurrentPath']),
    ...mapActions('session', ['loginByToken', 'acceptSiteAgreement']),
    ...mapActions('product', ['getProductBySlug', 'getProductById']),

    login(token) {
      this.setCurrentPath('');
      return this.loginByToken(token)
        .then((userinfo) => {
          const targetProductPage = cookies.get('targetProductPage');
          cookies.remove('targetProductPage', { path: '' });
          const { redirectAfterLoginPath } = this;
          this.redirectAfterLogin('');

          if (!userinfo.email) {
            return this.$router.push({ name: `profile-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
          }

          if (targetProductPage) {
            return this.getProductById(targetProductPage)
              .then((product) => this.$router.push({ name: `report-${this.$i18n.locale}`, params: { ...product, lang: this.$i18n.locale } }));
          }

          if (redirectAfterLoginPath) {
            return this.$router.push({ path: redirectAfterLoginPath });
          }

          return this.$router.push({ name: `home-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
        });
    },

    showAgreement(token) {
      this.isAgreementVisible = true;
      this.agreementToken = token;
      this.setCurrentPath('');
    },

    closeAgreement() {
      this.agreementToken = '';
      this.isAgreementVisible = false;
    },

    acceptAgreement(details) {
      if (this.isAgreementRequestInProgress) {
        return null;
      }

      this.isAgreementRequestInProgress = true;

      return this.acceptSiteAgreement({ agreementToken: this.agreementToken, ...details })
        .then(({ accessToken }) => {
          this.closeAgreement();
          return this.login(accessToken);
        })
        .finally(() => (this.isAgreementRequestInProgress = false));
    },
  },
  beforeCreate() {
    const { currentPath, token } = this.$store.state.session;

    if (token) {
      return this.$router.replace({ name: `home-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } });
    }

    if (currentPath && currentPath !== this.$route.fullPath) {
      return this.$router.replace({ path: currentPath, query: this.$route.query });
    }

    return Promise.resolve();
  },
  beforeDestroy() {
    this.setCurrentPath('');
  },
  metaInfo() {
    return {
      title: this.$t('login.meta.title'),
      meta: [
        { vmid: 'keywords', name: 'keywords', content: this.$t('login.meta.keywords') },
        { vmid: 'description', name: 'description', content: this.$t('login.meta.description') },
      ],
    };
  },
};
